<script>
import {
  WarehousePath,
  LocationPath,
  GravyPath,
  WareHouseStock,
  PackagingPath,
} from "@/path.js";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  props: [],
  components: { SelectWithSearch },
  data() {
    return {
      form: {
        warehouse_id: null,
        location_id: null,
        items: [],
      },
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      barcode: "",
      showBarcodeReader: false,
      fields: ["batch_code", "name", "inspected_qty"],
      items: [
        {
          batch_code: "049309324",
          name: "adlkadfa",
          quantity: "23",
        },
      ],
      currentPage: 1,
      search: "",
    };
  },
  mounted() {},
  methods: {
    async processBarcode() {
      if (this.barcode.includes("PG")) {
        await this.getBarcodeGravies();
      } else if (this.barcode.includes("PP")) {
        await this.getBarcodePackagings();
      }
      this.barcode = "";
      this.focusInput();
    },
    async getBarcodeGravies() {
      try {
        if (!this.form.warehouse_id) {
          Swal.fire("Please select the warehouse and location", "", "error");
          return;
        } else if (!this.form.location_id) {
          Swal.fire("Please select the location", "", "error");
          return;
        }
        let res = await axios.get(this.baseUrl + GravyPath.GRAVY_ORDER_LEVEL, {
          params: {
            page: this.currentPage,
            search: this.search,
            barcode: this.barcode,
          },
        });
        console.log(res, "res");
        if (res.data.status) {
          let d = res.data.data.data[0];
          let check = this.form.items.findIndex(
            (f) => f.id == d.id && f.batch_code == d.gravy_batch[0].batch_code
          );
          console.log(check);
          if (check !== -1) {
            this.form.items[check].inspected_qty += 1;
          } else {
            this.form.items.push({
              id: d.id,
              batch_code: d.gravy_batch[0].batch_code,
              gravy_id: d.id,
              name: d.name,
              packaging_id: "",
              inspected_qty: 1,
              best_before_date: d.gravy_batch[0].best_before_date,
            });
            // console.log(d);
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getBarcodePackagings() {
      try {
        if (!this.form.warehouse_id) {
          Swal.fire("Please select the warehouse and location", "", "error");
          return;
        } else if (!this.form.location_id) {
          Swal.fire("Please select the location", "", "error");
          return;
        }
        let res = await axios.get(
          this.baseUrl + PackagingPath.PACKAGING_ORDER_LEVEL,
          {
            params: {
              page: this.currentPPage,
              search: this.packaging_search,
              barcode: this.barcode,
            },
          }
        );
        if (res.data.status) {
          let d = res.data.data.data[0];
          let check = this.form.items.findIndex((f) => f.id == d.id);
          if (check !== -1) {
            this.form.items[check].inspected_qty += 1;
          } else {
            this.form.items.push({
              id: d.id,
              batch_code: d.packaging_batches[0].batch_code,
              packaging_id: d.packaging_batches[0].packaging_id,
              name: d.name,
              inspected_qty: 1,
              gravy_id: "",
            });
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async processBarcodeByCam(v) {
      this.barcode = v;
      if (this.barcode.includes("PG")) {
        await this.getBarcodeGravies();
      } else if (this.barcode.includes("PP")) {
        await this.getBarcocePackagings();
      }
      this.barcode = "";
    },
    focusInput() {
      this.$refs.barcodeInput?.focus();
    },
    minusQty(v) {
      let index = this.form.items.findIndex((f) => f.id == v.id);
      if (isNaN(this.form.items[index].inspected_qty)) {
        this.form.items[index].inspected_qty = 0;
      }
      if (parseInt(this.form.items[index].inspected_qty) - 1 < 1) {
        this.form.items.splice(index, 1);
        return;
      }
      this.form.items[index].inspected_qty =
        parseInt(this.form.items[index].inspected_qty) - 1;
      this.key += 1;
    },
    addQty(v) {
      let index = this.form.items.findIndex((f) => f.id == v.id);
      if (isNaN(this.form.items[index].inspected_qty)) {
        this.form.items[index].inspected_qty = 0;
      }
      this.form.items[index].inspected_qty =
        parseInt(this.form.items[index].inspected_qty) + 1;
      this.key += 1;
    },
    async saveList() {
      try {
        this.form.items.forEach((item) => {
          delete item.name;
          delete item.id;
        });

        console.log(this.form, "form");
        let res = await axios.post(
          this.baseUrl + WareHouseStock.SAVE_LIST,
          this.form
        );

        if (res.data.status) {
          Swal.fire("Success", "", "success");
          this.$bvModal.hide("add-stock-to-warehouse");
          this.$emit("reload");
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  watch: {
    form() {
      console.log(this.form, "af");
    },
  },
  computed: {
    WarehousePath() {
      return WarehousePath;
    },
    LocationPath() {
      return LocationPath;
    },
  },
};
</script>

<template>
  <b-card>
    <b-card-body>
      <b-row>
        <b-col sm="4">
          <label>Warehouse</label>
          <SelectWithSearch
            :selected_data="[form.warehouse_id]"
            selected_by="id"
            :search_api="WarehousePath.WAREHOUSE_SEARCH"
            track_by="id"
            display="name"
            @selectedOption="(v) => (form.warehouse_id = v)"
          ></SelectWithSearch>
        </b-col>
        <b-col sm="4" v-if="form.warehouse_id">
          <label>Location</label>
          <SelectWithSearch
            :selected_data="[form.location_id]"
            selected_by="id"
            :search_api="LocationPath.LOCATION_SEARCH"
            track_by="id"
            display="location"
            @selectedOption="(v) => (form.location_id = v)"
            :extra_params="'&warehouse_id=' + form.warehouse_id"
          ></SelectWithSearch>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <div class="row align-items-center pb-4">
            <div class="col-8">
              <input
                type="text"
                v-model="barcode"
                @keyup.enter="processBarcode"
                ref="barcodeInput"
                placeholder="Scan a barcode"
                class="form-control"
              />
            </div>
            <div class="col-2">
              <b-button
                v-if="showBarcodeReader == false"
                @click="() => (showBarcodeReader = true)"
                variant="success"
                class="ml-2"
              >
                <i class="fa fa-camera"></i>
              </b-button>
              <b-button
                v-else
                @click="() => (showBarcodeReader = false)"
                variant="danger"
                class="ml-2"
              >
                <i class="fa fa-times"></i>
              </b-button>
            </div>
          </div>
          <StreamBarcodeReader
            v-if="showBarcodeReader == true"
            @decode="processBarcodeByCam"
          ></StreamBarcodeReader>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-table :fields="fields" :items="form.items">
            <template v-slot:cell(inspected_qty)="row">
              <div>
                <b-input-group style="width: 130px">
                  <b-input-group-prepend>
                    <b-button @click="minusQty(row.item)" size="sm"
                      ><i class="fa fa-minus"></i
                    ></b-button>
                  </b-input-group-prepend>
                  <b-form-input
                    type="number"
                    :key="row.item.id + key"
                    :value="row.item.inspected_qty"
                    min="0"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button @click="addQty(row.item)" size="sm"
                      ><i class="fa fa-plus"></i
                    ></b-button>
                  </b-input-group-append>
                </b-input-group>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row class="my-1 mt-2">
        <b-col sm="12">
          <b-button @click="saveList" class="btn btn-success">Save</b-button>
        </b-col>
      </b-row>
    </b-card-body></b-card
  >
</template>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
